const K_COURIER_COMPANYS = [
  { id: 1, label: "Fedex ", value: "Fedex " },
  { id: 2, label: "UPS", value: "UPS" },
  { id: 3, label: "DHL", value: "DHL" },
  { id: 4, label: "Other", value: "Other" },
];

  export {K_COURIER_COMPANYS}